import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class StockMappingProvider extends HttpRequest {
  // Master — location กลาง (ไม่แยก store / warehouse)
  createLocations (payload) {
    this.setHeader(getAuthToken())
    return this.post('/stock-mapping/master', payload)
  }

  getLocationPaginate (query) {
    this.setHeader(getAuthToken())
    return this.get('/stock-mapping/master', query)
  }

  getLocationMappingPaginate (query) {
    this.setHeader(getAuthToken())
    return this.get('/stock-mapping/master/mapping', query)
  }

  getLocationByName (name) {
    this.setHeader(getAuthToken())
    return this.get('/stock-mapping/master/by-name', { name })
  }

  exportAllLocation (query) {
    this.setHeader(getAuthToken())
    return this.get('/stock-mapping/master/export-all-location', query)
  }

  getLocationById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/stock-mapping/master/${id}`)
  }

  updateLocationById (id, payload) {
    this.setHeader(getAuthToken())
    return this.patch(`/stock-mapping/master/${id}`, payload)
  }

  deleteLocationById (id) {
    this.setHeader(getAuthToken())
    return this.delete(`/stock-mapping/master/${id}`)
  }

  // Mapping — SKU ↔ location (ผูกกับ store จาก JWT)
  mappingLocation (payload) {
    this.setHeader(getAuthToken())
    return this.post('/stock-mapping/mapping', payload)
  }

  getMappingLocationPaginate (query) {
    this.setHeader(getAuthToken())
    return this.get('/stock-mapping/mapping', query)
  }

  getLocationMappingPaginateByCodes (body) {
    this.setHeader(getAuthToken())
    return this.post('/stock-mapping/mapping/by-codes', body)
  }

  getProductLocation (query) {
    this.setHeader(getAuthToken())
    return this.get('/stock-mapping/mapping/code', query)
  }

  exportLocationProduct (query) {
    this.setHeader(getAuthToken())
    return this.get('/stock-mapping/mapping/export-location-product', query)
  }

  getMappingById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/stock-mapping/mapping/${id}`)
  }

  moveLocation (payload) {
    this.setHeader(getAuthToken())
    return this.patch('/stock-mapping/mapping/move-location', payload)
  }

  decrementMappingQty (payload) {
    this.setHeader(getAuthToken())
    return this.patch('/stock-mapping/mapping/decrement-mapping-qty', payload)
  }

  setMappingQty (payload) {
    this.setHeader(getAuthToken())
    return this.patch('/stock-mapping/mapping/set-mapping-qty', payload)
  }

  updateMappingById (id, payload) {
    this.setHeader(getAuthToken())
    return this.patch(`/stock-mapping/mapping/${id}`, payload)
  }

  clearLocation (payload) {
    this.setHeader(getAuthToken())
    return this.put('/stock-mapping/mapping/clear-location', payload)
  }

  deleteMappingById (id) {
    this.setHeader(getAuthToken())
    return this.delete(`/stock-mapping/mapping/${id}`)
  }
}

export default StockMappingProvider
